<div class="row gap-16 space-between align-center">
  <h1 i18n>Welcome {{ user }}</h1>
  <rr-icon name="close" class="pointer" (click)="close()"></rr-icon>
</div>
<h2 i18n>How shall we start?</h2>
<div class="col gap-16 w100">
  <rr-btn class="w100" type="Secondary" size="large" tone="brand" (btnclick)="close('guide-me')">
    Guide me step by step
  </rr-btn>
  <rr-btn class="w100" [disabled]="true" type="Secondary" size="large" tone="brand">Upload existing Pitch Deck</rr-btn>
  <rr-btn class="w100" type="Secondary" size="large" tone="brand" (btnclick)="close('upload-paper')">
    Upload a Scientific Paper as idea basis
  </rr-btn>
</div>
